import { Card, Col, Row, Select, Typography } from "antd";
import { useState } from "react";
import BarChart from "../../components/charts/apexBarChart";
import HeatMapChart from "../../components/charts/apexHeatMapChart";
import useAttentionV2 from "../../hooks/useAttentionV2";
import { PEAK_HOURS_METRICS } from "../../utils/constants";
import { graficosDoPico } from "./picoDaV2";

const { Text } = Typography;

const options = [
  {
    value: "occupied_time_accum",
    label: "Tempo de atenção acumulado",
  },
  {
    value: "peak_people",
    label: "Pico de pessoas",
  },
  {
    value: "occupancy_rate",
    label: "Porcentagem de ocupação",
  },
];

export default function ChartsWrapper({ branchId, periodo, filtrosDaAtencao }) {
  const [selectedMetric, setSelectedMetric] = useState("occupied_time_accum");

  const porHoraEDia = useAttentionV2({
    branchId,
    start: periodo?.start,
    end: periodo?.end,
    groupBy: "hour_weekday",
    filtros: filtrosDaAtencao,
  });
  const porDia = useAttentionV2({
    branchId,
    start: periodo?.start,
    end: periodo?.end,
    groupBy: "weekday",
    filtros: filtrosDaAtencao,
  });
  const graficos =
    porHoraEDia.data && porDia.data
      ? graficosDoPico({
          porHoraEDia: porHoraEDia.data,
          porDia: porDia.data,
          metrica: selectedMetric,
        })
      : null;
  const barGraphData = graficos?.barGraphData;
  const matrixGraphData = graficos?.matrixGraphData;
  const loadingGraphData = porHoraEDia.isLoading || porDia.isLoading;

  const metric = PEAK_HOURS_METRICS.find(
    (currentMetric) => currentMetric.key === selectedMetric
  );

  return (
    <Card
      title={"Gráficos de análise"}
      align="center"
      style={{ width: "85%" }}
      loading={loadingGraphData}
      styles={{
        header: {
          backgroundColor: "var(--ouran-card-header-bg)",
        },
      }}>
      <Row style={{ marginBottom: 50 }}>
        <Col span={24}>
          <Text strong style={{ marginRight: 10 }}>
            {"Escolha qual métrica deseja visualizar:"}
          </Text>

          <Select
            options={options}
            style={{
              width: "30%",
            }}
            value={selectedMetric}
            onChange={(value) => setSelectedMetric(value)}
          />
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          {matrixGraphData && (
            <HeatMapChart
              key={selectedMetric}
              data={matrixGraphData}
              suffix={metric?.suffix}
              formatter={metric?.formatter}
            />
          )}
        </Col>
        <Col span={12}>
          {barGraphData && (
            <BarChart
              key={selectedMetric}
              data={barGraphData}
              suffix={metric?.suffix}
              formatter={metric?.formatter}
              metric={metric?.label}
            />
          )}
        </Col>
      </Row>
    </Card>
  );
}
